import Dimensions from "./Dimensions";

export default Dimensions;
